<script type="text/jsx">
    import Vue from 'vue'
    export default {
        computed : {
            isGc: function () {
                return false;
            },
            hasLocations: function () {
                if (this.isGc) {
                    return false;
                }
                if (this.isLocationPreferenceAllowed) {
                    if ('options' in this.product && this.product.options) {
                        var options = this.product.options;
                        if ('location_preference' in options) {
                            if ('locations' in options.location_preference) {
                                var locationsList = options.location_preference.locations;
                                return Object.keys(locationsList).length > 0 ? true : false;
                            }
                        }
                    }
                }
                return false;
            },
            hasLogos: function () {
                if (this.isGc) {
                    return false;
                }
                if (this.isMultiLogoAllowed) {
                    if ('options' in this.product && this.product.options) {
                        var options = this.product.options;
                        if ('logo' in options) {
                            var logosList = options.logo;
                            return Object.keys(logosList).length > 0 ? true : false;
                        }
                    }
                }
                return false;
            }
        },
        methods: {
            validateProductProperties: function () {
                // currently assuming that a brick has a location or a logo, but not both simultaneously
                return new Promise((resolve, reject) => {
                    if (this.hasLocations) {
                        this.$refs['prefloc'].$validator.validateAll().then((result) => {
                            console.log('Preferred Location validation result:', result);
                            if (!result) {
                                reject();
                            }
                            resolve();
                        }).catch(function () {
                            console.log('Preferred Location failed due to validation errors!');
                            reject();
                        });
                    } else if (this.hasLogos) {
                        this.$refs['preflog'].$validator.validateAll().then((result) => {
                            console.log('Preferred Logo validation result:', result);
                            if (!result) {
                                reject();
                            }
                            resolve();
                        }).catch(function () {
                            console.log('Preferred Logo failed due to validation errors!');
                            reject();
                        });
                    } else {
                        resolve();
                    }
                });
            },
            is4x8: function (itemImageBlank) {
                return itemImageBlank.indexOf('4x8') !== -1;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// product-handling.vue?7708e12e